import src from "IMAGE";
export default { src, width: 3715, height: 392, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABhMSmUIGRkhBhcYHwcXFx4FEA8VCBkXIAoaGCELHholQIcDbNkE3A0AAAAASUVORK5CYII="};
